import React from "react";
import { AnimatedCertificates } from "@/components/common/animated-certificates";

import cert0 from "../../assets/images/certificates/Hackaton-Certificate-2.webp";
import cert1 from "../../assets/images/certificates/Certificate_of_Completion.webp";
import cert2 from "../../assets/images/certificates/Certificate_of_Completion_1.webp";

import cert3 from "../../assets/images/certificates/Certificate_of_Completion_2.webp";
import cert4 from "../../assets/images/certificates/Certificate_of_Completion_3.webp";
import cert5 from "../../assets/images/certificates/Certificate_of_Completion_4.webp";
import cert6 from "../../assets/images/certificates/Certificate_of_Completion_5.webp";
import cert7 from "../../assets/images/certificates/Certificate_of_Completion_6.webp";

function Certificates() {
  const certificates = [
    {
      quote:
        "In recognition of your outstanding achievement and dedication as one of the Top 10 Finalists of the START Hackathon 2023.",
      name: "Certificate of Appreciation",
      designation: "START Hackathon 2023 4th Place Winner",
      src: cert0,
    },
    {
      quote: "Completed the TESDA NC I course in Visual Graphic Design",
      name: "Certificate of Completion",
      designation: "Visual Graphic Design",
      src: cert1,
    },
    {
      quote: "Completed the TESDA NC I course in Developing Designs for Logo",
      name: "Certificate of Completion",
      designation: "Developing Designs for Logo",
      src: cert2,
    },
    {
      quote:
        "Completed the TESDA NC I course in Developing Design for Print Media",
      name: "Certificate of Completion",
      designation: "Developing Design for Print Media",
      src: cert3,
    },
    {
      quote:
        "Completed the TESDA NC I course in Developing Design for User Experience",
      name: "Certificate of Completion",
      designation: "Developing Design for User Experience",
      src: cert4,
    },
    {
      quote:
        "Completed the TESDA NC I course in Developing Design for User Interface",
      name: "Certificate of Completion",
      designation: "Developing Design for User Interface",
      src: cert5,
    },
    {
      quote:
        "Completed the TESDA NC I course in Developing Design for Product Packaging",
      name: "Certificate of Completion",
      designation: "Developing Design for Product Packaging",
      src: cert6,
    },
    {
      quote:
        "Completed the TESDA NC I course in Designing Booth and Product/Window Display",
      name: "Certificate of Completion",
      designation: "Designing Booth and Product/Window Display",
      src: cert7,
    },
  ];

  return (
    <div
      id="certificates"
      className="w-full relative flex flex-col justify-center items-center bg-transparent text-[#c5c6c7] min-h-screen py-10"
    >
      <div className="text-center mb-10 w-full">
        <h2 className="text-4xl md:text-5xl font-bold text-[#34abe1] tracking-tight">
          Certificates
        </h2>
        <p className="mt-4 text-lg max-w-2xl mx-auto text-white opacity-80">
          A showcase of my continuous learning and professional development
          achievements.
        </p>
      </div>
      <div className="w-full">
        <AnimatedCertificates testimonials={certificates} />
      </div>
    </div>
  );
}

export default Certificates;
